import styled, { css } from 'styled-components';

import { ReactComponent as TerminalsIconBase } from 'assets/icons/terminals-active.svg';
import { ReactComponent as InformationBase } from 'assets/icons/information.svg';

export const TerminalsIcon = styled(TerminalsIconBase)`
  cursor: pointer;
`;

export type InformationIconStylesProps = {
  disabled?: boolean;
};

export const InformationIcon = styled(InformationBase)<InformationIconStylesProps>(
  ({ disabled, theme }) => css`
    cursor: pointer;
    opacity: ${disabled ? 0.5 : 1};
    width: 24px;
    height: 24px;
    vertical-align: middle;

    path {
      fill: ${disabled ? theme?.palette?.grey?.[600] || '#BDBDBD' : '#2D6CE6'};
    }
  `,
);

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
`;
